export const USER_TYPES = {
  LOGIN: 'LOGIN',
  DETAILS: 'DETAILS',
  LOGOUT: 'LOGOUT',
};
